const BillingInvoiceItem = ({
    chargeAmount = '',
    chargeName = [],
    city = '',
    feedId = '',
    feedListingId = '',
    productName = '',
    propertyName = '',
    quantity = 0,
    serviceEndDate = '',
    serviceStartDate = '',
    state = '',
    address = '',
    unit = '',
    activeRanges = '',
} = {}) => ({
    chargeAmount: Number(chargeAmount),
    chargeName: String(chargeName),
    city: String(city),
    feedId: String(feedId),
    feedListingId: String(feedListingId),
    productName: String(productName),
    propertyName: String(propertyName),
    quantity: Number(quantity),
    serviceEndDate: String(serviceEndDate),
    serviceStartDate: String(serviceStartDate),
    state: String(state),
    address: String(address),
    unit: String(unit),
    activeRanges: String(activeRanges),
});

export default BillingInvoiceItem;
